import React from 'react'
import styles from './StandardLayout.scss'
import { CollapseProvider } from './StandardLayoutContexts'
import { GlobalNav } from 'common/GlobalNav'
import { GlobalFooter } from 'common/GlobalFooter'
import { base } from 'lib/styleguide/base.scss'
import cx from 'classnames'
import { injectIntl } from 'react-intl'

export const _StandardLayout = ({ children, greyBg, overrideNav, className, withCollapseProvider }) => {
  const wrap = <div className={cx(styles.StandardLayout, base, greyBg && styles.greyBg, className)}>
    {overrideNav || <GlobalNav />}
    <div className={styles.content}>
      {children}
    </div>
    <GlobalFooter />
  </div>

  return withCollapseProvider
    ? <CollapseProvider>
      {wrap}
    </CollapseProvider>
    : wrap
}

export const StandardLayout = injectIntl(_StandardLayout)
